export default {"src":"/_next/static/media/for-publishers-3.233463c0.svg","height":1387,"width":1440};